import { useMutation } from '@tanstack/react-query'

import { getPaymentLink } from '../paymentsService'

export function useGetPaymentLink() {
  return useMutation({ mutationFn: getPaymentLink })
}
